module.exports = __webpack_public_path__ + "img/audio-new.94237904.svg";